export default __webpack_public_path__ + "static/media/demo-4.3b3a758c.png";